//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getCookie} from '@/utils/index'

export default {
  name: 'LandingPageHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loginStatus: {}
    }
  },
  methods: {
        // getUserInfo () {
        //   fetchUser().then(resp => {
        //     this.userInfo = resp.data
        //   })
        // }
  },
  mounted () {
    this.loginStatus = !!getCookie('token')
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageHeaderXhs.vue